import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localePl from '@angular/common/locales/pl';
import { AuthInterceptorProvider } from '../modules/core/services/auth-interceptor/auth-interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CalendarModule } from 'angular-calendar';
import { CommonModule, registerLocaleData } from '@angular/common';
import { CustomDateFormatter } from '../utils/custom-date-formatter';
import { DataService } from '../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { DirectivesModule } from '../shared/directives/directives.module';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ImgCacheModule } from 'ng-imgcache';
import { IonicApp, IonicModule } from 'ionic-angular';
import { LogoutService } from '../shared/services/logout.service';
import { MatPaginatorI18n } from '../utils/mat-pagination-i18n';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MyApp } from './app.component';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { OAuthModule } from 'angular-oauth2-oidc-codeflow';
import { ProjectsModule } from '../modules/projects/pages/projects.module';
import { SellionsAchievementModule } from '../modules/achievement/achievement.module';
import { SellionsAuditsModule } from '../modules/audits/audits.module';
import { SellionsCalendarModule } from '../modules/calendar/calendar.module';
import { SellionsClientsModule } from '../modules/clients/clients.module';
import { SellionsCoreModule } from '../modules/core/core.module';
import { SellionsKnowledgeModule } from '../modules/knowledge/knowledge.module';
import { SellionsNewsModule } from '../modules/news/news.module';
import { SellionsPluginsModule } from '../modules/plugins/plugins.module';
import { SellionsPrizesModule } from '../modules/prizes/prizes.module';
import { SellionsQuizzesModule } from '../modules/quizzes/quizzes.module';
import { SellionsRankingModule } from '../modules/ranking/ranking.module';
import { SellionsVisitTaskModule } from '../modules/engine/engine.module';
import { SettingsPageModule } from '../modules/core/pages/settings/settings.module';
import { SuperTabsModule } from 'ionic2-super-tabs';
import { TasksModule } from '../modules/tasks/pages/tasks.module';
import { TrackJsErrorHandler } from '../providers/track-js-error-handler/track-js-error-handler';
import { UserTasksModule } from '../modules/user-tasks/pages/user-tasks.module';

registerLocaleData(localePl, 'pl');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [MyApp],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    DirectivesModule,
    HttpClientModule,
    ImgCacheModule,
    FormsModule,
    NguiAutoCompleteModule,
    IonicModule.forRoot(MyApp, {
      mode: 'md',
    }),
    SuperTabsModule.forRoot(),
    CalendarModule.forRoot(),
    SellionsCalendarModule,
    SellionsCoreModule,
    SellionsPluginsModule,
    SellionsClientsModule,
    SellionsKnowledgeModule,
    SellionsQuizzesModule,
    SellionsNewsModule,
    SellionsRankingModule,
    SellionsPrizesModule,
    SellionsAchievementModule,
    SellionsAuditsModule,
    SellionsVisitTaskModule,
    OAuthModule.forRoot(),
    TasksModule,
    ProjectsModule,
    SettingsPageModule,
    UserTasksModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    { provide: ErrorHandler, useClass: TrackJsErrorHandler },
    CustomDateFormatter,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorProvider,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'pl' },
    { provide: MatPaginatorIntl, useClass: MatPaginatorI18n },
    LogoutService,
    DataService,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts